// utils/skillHelpers.js
export const isDuplicateSkill = (skillIdOrTitle, skillsArray) => {
  if (!Array.isArray(skillsArray)) return false;

  const checkValue = String(skillIdOrTitle)?.toLowerCase(); // ✅ convert input to string

  return skillsArray.some((skill) => {
    const skillTitle = skill?.title ? String(skill.title)?.toLowerCase() : "";
    const skillId = skill?.id;
    return skillId == skillIdOrTitle || skillTitle == checkValue;
  });
};
